import LinearProgress from '@mui/material/LinearProgress';
import { useEffect, useRef, useState } from 'react';
import { LinearLoaderWrapper } from '@styles/GridStyles';
import { randomNumber } from '../../../../commonFunctions';

export interface ILinearLoaderProps {
  isBuffer?: boolean;
  fullWidth?: boolean;
}

export const LinearLoader = ({ isBuffer, fullWidth }: ILinearLoaderProps) => {
  const initProgress = randomNumber(0, 40);
  const initBuffer = initProgress + 1;

  const [progress, setProgress] = useState(initProgress);
  const [buffer, setBuffer] = useState(initBuffer);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const progressRef = useRef(() => {});

  useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(initProgress);
        setBuffer(initBuffer);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 300);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <LinearLoaderWrapper fullWidth={fullWidth}>
      <LinearProgress
        color="info"
        variant={isBuffer ? 'buffer' : 'determinate'}
        value={progress}
        valueBuffer={buffer}
      />
    </LinearLoaderWrapper>
  );
};
